import { create } from "zustand";
import { produce } from "immer";

const defaultData = {
  isLoading: false,
  isWaiting: false,
  petsReport: [],
  summary: { petTotal: 0, withPackage: 0, subscribers: 0 },
  filter: {
    dateFrom: null,
    dateTo: null,
    hasPackage: "*",
    isSubscriber: "*",
    minAbsenceDays: "30",
    cpf: "",
    search: "",
  },
  sort: { sortBy: "petName", sortOrder: "asc" },
  pagination: { page: 0, totalPages: 0, perPage: 50, totalDocuments: 0 },
};

export const usePetsReport = create((set) => ({
  data: defaultData,
  actions: {
    setPetsReport: (pets, pagination) =>
      set((state) =>
        produce(state, (draft) => {
          const page = typeof pagination === "number" ? pagination : pagination.page;
          draft.data.petsReport[page] = pets;
          draft.data.pagination = pagination;
          draft.data.isLoading = false;
          draft.data.isWaiting = false;
        })
      ),
    setSummary: (summary) =>
      set((state) =>
        produce(state, (draft) => {
          draft.data.summary = { ...state.data.summary, ...summary };
        })
      ),
    setFilter: (filterProps) =>
      set((state) =>
        produce(state, (draft) => {
          draft.data.filter = { ...state.data.filter, ...filterProps };
        })
      ),
    setSort: (sortProps) =>
      set((state) =>
        produce(state, (draft) => {
          draft.data.sort = { ...state.data.sort, ...sortProps };
        })
      ),
    setPaginationPage: (page) =>
      set((state) =>
        produce(state, (draft) => {
          draft.data.pagination.page = page;
        })
      ),
    setLoading: (status) =>
      set((state) =>
        produce(state, (draft) => {
          draft.data.isLoading = status;
          draft.data.isWaiting = status;
        })
      ),
    setWaiting: (status) =>
      set((state) =>
        produce(state, (draft) => {
          draft.data.isWaiting = status;
        })
      ),
    clearPetsReport: () =>
      set((state) =>
        produce(state, (draft) => {
          draft.data.petsReport = [];
        })
      ),
    clear: () =>
      set((state) =>
        produce(state, (draft) => {
          draft.data = defaultData;
        })
      ),
  },
}));
